import React, { Fragment, useState, useRef, useEffect } from "react"
import { accessRole } from "../../../../../helpers/access_role"
import Select from "../../../../../helpers/ui/CustomSelect"
import apiResponse from "../../../../../services/apiResponse"
import { Link } from "react-router-dom"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Input, Label,
} from "reactstrap"

import IndexBloc from './Blocs/IndexBloc'
import TablePrimaryComponent from './Components/TablePrimaryComponent'
import moment from "moment"
import DatePicker from "../../../../../helpers/ui/DatePicker"

const statusCuti = [
    { value: -1, label: 'Menunggu Proses Persetujuan Atasan' },
    { value: 0, label: 'Menunggu Proses Persetujuan Admin' },
    { value: 1, label: 'Disetujui' },
    { value: 2, label: 'Ditolak' },
    { value: 3, label: 'Dalam Proses Pembatalan' },
    { value: 4, label: 'Cuti Dibatalkan' },
]

const FILTER_STORAGE_KEY = 'historyHomeKepegawaianCutiListPegawaiFilter'

const getStoredFilter = () => {
    try {
        const raw = sessionStorage.getItem(FILTER_STORAGE_KEY)
        return raw ? JSON.parse(raw) : null
    } catch (error) {
        return null
    }
}

const ListPegawaiView = (props) => {

    let indexBloc = new IndexBloc();

    const userdata = JSON.parse(localStorage.getItem('userdata'));
    const employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'))
    const peg_detail = !accessRole('approve') ? (userdata != null ? userdata : "") 
    : (employeeSeleted != null ? employeeSeleted : "")

    console.log(employeeSeleted)

    const currentRoleId = JSON.parse(localStorage.getItem('currentRoleId'));

    const activeRef = useRef();
    const [filter, setFilter] = useState(() => getStoredFilter()?.filter)
    const [dateStart, setDateStart] = useState(() => getStoredFilter()?.dateStart || moment().startOf('month').format('YYYY-MM-DD'))
    const [dateEnd, setDateEnd] = useState(() => getStoredFilter()?.dateEnd || moment().endOf('month').format('YYYY-MM-DD'))
    const [status, setStatus] = useState(() => getStoredFilter()?.status ?? null)
    const [optionTypes, setOptionTypes] = useState([]);
    const [cutiType, setCutiType] = useState(() => getStoredFilter()?.cutiType ?? null)

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => activeRef.current.setTokenAPI()

    const persistFilter = (newFilter) => {
        try {
            sessionStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify({
                dateStart,
                dateEnd,
                status,
                cutiType,
                filter: newFilter
            }))
        } catch (error) {}
    }

    useEffect(() => {
        // console.log( userdata)
        indexBloc.typeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let type = result.data.response.result
                    setOptionTypes(type)
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })
        
        indexBloc.fetchTypeList({})

        return () => {
            indexBloc.typeChannel?.unsubscribe()
        }
    }, [])

    const handleButtonSearch = () => {
        if (dateStart && dateEnd) {
            const newFilter = {
                'dateStart': dateStart,
                'dateEnd': dateEnd,
                'status': status,
                'paid_leave_type_uuid': cutiType || ""
            }
            setFilter(newFilter)
            persistFilter(newFilter)
            setTimeout(() => {
                reloadActiveRef()
            }, 300);
        } else if (status) {
            const newFilter = {
                'status': status
            }
            setFilter(newFilter)
            persistFilter(newFilter)
            setTimeout(() => {
                reloadActiveRef()
            }, 300);
        }
    }
    return (
        <Fragment>
            <Container fluid>
                <Card>
                    <CardBody>
                        <div className="float-end ms-2">
                        {
                            (accessRole('create')) ?
                                <Link to="?create">
                                    <Button color="primary">Pengajuan Cuti</Button>
                                </Link>
                            : null
                        }
                        </div>
                        <div className="float-end">
                        {
                            (accessRole('read')) && currentRoleId == 2 ?
                                <Link to={`?saldo&uuid=${peg_detail.employee_uuid}`}>
                                    <Button color="info">Saldo Cuti</Button>
                                </Link>
                            : null
                        }
                        {
                            currentRoleId == 1 &&
                            <div className="float-end">
                                <Link to={`/izinpegawai/cuti.html?list_pegawai`}>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>
                        }
                        </div>
                        <CardTitle>Daftar Cuti</CardTitle>
                        <CardSubtitle className="mb-3">
                            Kelola Daftar Cuti
                        </CardSubtitle>
                        <hr />
                        <Row className="mb-1">
                            <label className="col-md-3">
                                NIP
                            </label>
                            <Col md="9">
                                {
                                    peg_detail.employee_nip
                                }
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <label className="col-md-3">
                                Nama
                            </label>
                            <Col md="9">
                                {
                                    peg_detail.employee_full_name
                                }
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <label className="col-md-3">
                                Jabatan
                            </label>
                            <Col md="9">
                                {
                                    peg_detail.employee_current_position_name
                                }
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <label className="col-md-3">
                                Unit Kerja {userdata?.is_atasan}
                            </label>
                            <Col md="9">
                                {
                                    peg_detail.employee_current_work_unit_name
                                }
                            </Col>
                        </Row>
                        {
                            userdata?.is_atasan == 1 && currentRoleId != 1 ?
                                <Row className="mb-1">
                                    <Col md="10">
                                        <Link to="?list_bawahan">
                                            <Button color="primary">List Cuti Bawahan</Button>
                                        </Link>
                                    </Col>
                                </Row>
                            : ""
                        }

                        <hr/>
                        <Row className="mb-3">
                            <Label className="col-md-3 col-form-label">
                                Filter Tanggal Mulai
                            </Label>
                            <Col md="3">
                                {/* <Input placeholder="Tanggal Mulai" type="date" onChange={e => setDateStart(e.target.value)} value={dateStart} /> */}
                                <DatePicker 
                                    name="start_date"
                                    isWeekday={false}
                                    dateFormat="dd/MM/yyyy"
                                    placeholder="Tanggal Mulai"
                                    isAvForm={false}
                                    onChange={val => setDateStart(moment(val).format('YYYY-MM-DD'))}
                                    defaultValue={dateStart}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Label className="col-md-3 col-form-label">
                                Filter Tanggal Selesai
                            </Label>
                            <Col md="3">
                                {/* <Input placeholder="Tanggal Selesai" type="date" onChange={e => setDateEnd(e.target.value)} value={dateEnd} /> */}
                                <DatePicker 
                                    name="end_date"
                                    isWeekday={false}
                                    dateFormat="dd/MM/yyyy"
                                    placeholder="Tanggal Selesai"
                                    isAvForm={false}
                                    onChange={val => setDateEnd(moment(val).format('YYYY-MM-DD'))}
                                    defaultValue={dateEnd}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Label className="col-md-3 col-form-label">
                                Jenis Cuti
                            </Label>
                            <Col md="3">
                                <Select 
                                    options={optionTypes} 
                                    isAvForm={false} 
                                    isClearable={true} 
                                    optionLabel="paid_leave_type_name"
                                    optionValue="paid_leave_type_uuid"
                                    defaultValue={cutiType}
                                    onChange={opt => setCutiType(opt ? opt.paid_leave_type_uuid : null)} 
                                />
                            </Col>
                        </Row>                     
                        <Row className="mb-3">
                            <Label className="col-md-3 col-form-label">
                                Status Cuti
                            </Label>
                            <Col md="3">
                                <Select options={statusCuti} isAvForm={false} isClearable={true} defaultValue={status} onChange={opt => setStatus(opt ? opt.value : null)} />
                            </Col>
                        </Row>  
                        <Row className="mb-3">
                            <Col md="3"></Col>
                            <Col md="10">
                                <Button 
                                    color="primary" 
                                    type="button"
                                    onClick={() => {
                                        handleButtonSearch()
                                    }}
                                >
                                    <i className="uil-search-alt"></i> Cari
                                </Button>
                            </Col>
                        </Row>
                        <hr/>
                        <TablePrimaryComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef} employee={peg_detail} filter={filter} />
                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    )

}

export default ListPegawaiView